import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const MandatoryLegalForm = () => {
  const { t } = useTranslation();
  return (
    <Stack
      sx={{
        backgroundColor: 'primaryDark.150',
        p: 3,
        color: 'primaryDark.500',
        borderRadius: 2,
        '& span': {
          display: 'block',
        },
      }}
    >
      <Typography
        variant="body3"
        sx={{
          textAlign: 'justify',
          pb: 4,
        }}
      >
        <Typography
          variant="heading3"
          sx={{
            textAlign: 'left',
            pb: 0.5,
          }}
        >
          {t('contracts.legalForm.paymentMethod.title')}
        </Typography>
        {t('contracts.legalForm.paymentMethod.part1')} <br /> <br />
        {t('contracts.legalForm.paymentMethod.part2')}
      </Typography>
      <Typography
        variant="body3"
        sx={{
          textAlign: 'justify',
          pb: 4,
        }}
      >
        <Typography
          variant="heading3"
          sx={{
            textAlign: 'left',
            pb: 0.5,
          }}
        >
          {t('contracts.legalForm.noAgency.title')}
        </Typography>
        {t('contracts.legalForm.noAgency.part1')}
      </Typography>
      <Typography
        variant="body3"
        sx={{
          textAlign: 'justify',
          pb: 4,
        }}
      >
        <Typography
          variant="heading3"
          sx={{
            textAlign: 'left',
            pb: 0.5,
          }}
        >
          {t('contracts.legalForm.warrants.title')}
        </Typography>
        {t('contracts.legalForm.warrants.part1')}
        <Typography
          variant="body3"
          sx={{
            p: 1,
            pl: 2,
            pt: 1.5,
            textAlign: 'left',
          }}
        >
          {t('contracts.legalForm.warrants.part2')}
        </Typography>
        <Typography
          variant="body3"
          sx={{
            p: 1,
            pl: 2,
            textAlign: 'left',
          }}
        >
          {t('contracts.legalForm.warrants.part3')}
        </Typography>
      </Typography>
      <Typography
        variant="body3"
        sx={{
          textAlign: 'justify',
          pb: 4,
        }}
      >
        <Typography
          variant="heading3"
          sx={{
            textAlign: 'left',
          }}
        >
          {t('contracts.legalForm.indemnity.title')}
        </Typography>
        {t('contracts.legalForm.indemnity.part1')}
        <Typography
          variant="body3"
          sx={{
            p: 1,
            pl: 2,
            pt: 1.5,
            textAlign: 'left',
          }}
        >
          {t('contracts.legalForm.indemnity.part2')}
        </Typography>
        <Typography
          variant="body3"
          sx={{
            p: 1,
            pl: 2,
            textAlign: 'left',
          }}
        >
          {t('contracts.legalForm.indemnity.part3')}
        </Typography>
        <Typography
          variant="body3"
          sx={{
            p: 1,
            pl: 2,
            textAlign: 'left',
          }}
        >
          {t('contracts.legalForm.indemnity.part4')}
        </Typography>
      </Typography>

      <Typography
        variant="body3"
        sx={{
          textAlign: 'justify',
          pb: 4,
        }}
      >
        <Typography
          variant="heading3"
          sx={{
            textAlign: 'left',
            pb: 0.5,
          }}
        >
          {t('contracts.legalForm.limitationOfLiability.title')}
        </Typography>
        {t('contracts.legalForm.limitationOfLiability.part1')} <br /> <br />
        {t('contracts.legalForm.limitationOfLiability.part2')} <br /> <br />
        {t('contracts.legalForm.limitationOfLiability.part3')}
        <Typography
          variant="body3"
          sx={{
            pl: 4,
            textAlign: 'left',
          }}
        >
          <ul style={{ paddingTop: '12px' }}>
            <li style={{ padding: '8px' }}>
              {t('contracts.legalForm.limitationOfLiability.part4')}
            </li>
            <li style={{ padding: '8px' }}>
              {t('contracts.legalForm.limitationOfLiability.part5')}
            </li>
            <li style={{ padding: '8px' }}>
              {t('contracts.legalForm.limitationOfLiability.part6')}
            </li>
          </ul>
        </Typography>
      </Typography>

      <Typography
        variant="body3"
        sx={{
          textAlign: 'justify',
          pb: 4,
        }}
      >
        <Typography
          variant="heading3"
          sx={{
            textAlign: 'left',
            pb: 0.5,
          }}
        >
          {t('contracts.legalForm.severability.title')}
        </Typography>
        {t('contracts.legalForm.severability.part1')}
      </Typography>
      <Typography
        variant="body3"
        sx={{
          textAlign: 'justify',
          pb: 4,
        }}
      >
        <Typography
          variant="heading3"
          sx={{
            textAlign: 'left',
            pb: 0.5,
          }}
        >
          {t('contracts.legalForm.waiver.title')}
        </Typography>
        {t('contracts.legalForm.waiver.part1')}
      </Typography>
      <Typography
        variant="body3"
        sx={{
          textAlign: 'justify',
          pb: 4,
          display: 'block',
        }}
      >
        <Typography
          variant="heading3"
          sx={{
            textAlign: 'left',
            pb: 0.5,
          }}
        >
          {t('contracts.legalForm.disputeResolution.title')}
        </Typography>
        <Typography
          variant="heading3"
          sx={{
            textTransform: 'none',
            textAlign: 'left',
            pb: 0.5,
          }}
        >
          {t('contracts.legalForm.disputeResolution.part1')}
        </Typography>
        {t('contracts.legalForm.disputeResolution.part2')}
        <br /> <br />
        {t('contracts.legalForm.disputeResolution.part2')}
      </Typography>
    </Stack>
  );
};

export default MandatoryLegalForm;
